import * as dayjs from 'dayjs';

export const getCurrentMonthDate = () => {
  const month = dayjs();

  return {
    label: month.format('MMMM'),
    start_date: month.format('01-MM-YYYY'),
    start_date_label: month.format('01/MM/YY'),
    end_date: month.endOf('month').format('DD-MM-YYYY'),
    end_date_label: month.endOf('month').format('DD/MM/YY'),
    progressive: month.format('YYYYMM'),
    year: month.format('YYYY'),
  };
};
